import { motion } from "framer-motion";

const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

const TestimonialBox = (props) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="testimonial-box"
    >
      <div className="box-header">
        <div className="avatar" aria-hidden="true">
          {getInitials(props.userName)}
        </div>
        <div className="profile-details">
          <h5>{props.userName}</h5>
          <p>{props.title}</p>
        </div>
      </div>
      <div className="box-body">
        <p>{props.description}</p>
      </div>
    </motion.div>
  );
};

const Testimonials = () => {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="testimonials"
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-12 col-sm-12">
            <div className="heading">
              <h2>WHAT ARE MY CLIENTS SAYING ABOUT ME</h2>
            </div>
          </div>
        </div>
        <div className="row gy-4 mt-2">
          <div className="col-xl-4 col-sm-12">
            <TestimonialBox
              userName="Karen W."
              title="Sold 2 properties and purchased another"
              description="Rosanne is the best realtor I have ever worked with. She helped me sell two properties and purchase another. She's professional, hard working, and always on top of it, with an excellent team handling title and escrow. My transactions weren't easy, but she knew how to find solutions and get it done. Rosanne is a blessing!"
            />
          </div>
          <div className="col-xl-4 col-sm-12">
            <TestimonialBox
              userName="Anna Åsberg"
              title="Bought a second home in Newport Beach"
              description="Rosanne helped me find a second home in Newport Beach while I was on the east coast, giving me virtual tours and lining up showings. She always looked out for my best interest and negotiated well on my behalf, and went above and beyond to make the place move-in ready. The best Realtor I have ever worked with!"
            />
          </div>
          <div className="col-xl-4 col-sm-12">
            <TestimonialBox
              userName="Joseph Phillips"
              title="A skilled negotiator and a pleasure to work with"
              description="Rosanne Rojo is hands down one of the best realtors I've ever worked with, and her energy is absolutely contagious! She uses her experience and knowledge of the local market to explain exactly what to expect throughout the transaction. A skilled negotiator and an absolute pleasure to work with!"
            />
          </div>
          <div className="col-xl-4 col-sm-12">
            <TestimonialBox
              userName="Kristi Wry"
              title="Knowledgeable and highly respected"
              description="Rosanne is extremely knowledgeable and prides herself in helping clients achieve their real estate dreams. She's dedicated to getting the best offers for her sellers and the right home for her buyers. Extremely professional and highly respected by her peers, she serves Cypress, Yorba Linda, La Palma, Long Beach and surrounding cities."
            />
          </div>
          <div className="col-xl-4 col-sm-12">
            <TestimonialBox
              userName="Magdalena Pelayo"
              title="Sold my properties"
              description="I am very happy that I chose Rosanne to sell my properties. She was very knowledgeable, sincere, honest and kind. I would highly recommend her to anyone who is looking for an amazing realtor. Thank you, Rosanne!"
            />
          </div>
          <div className="col-xl-4 col-sm-12">
            <TestimonialBox
              userName="Moawad Ebrahem"
              title="Exceptional and always available"
              description="Rosanne Rojo is an exceptional realtor. She is knowledgeable, professional, and always available to help. Thanks to her dedication and expertise, every step felt smooth and reassuring. Highly recommend!"
            />
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Testimonials;
